import { apiClient } from './client';

/**
 * hold   Park every message in the DLQ; release later with Reprocess.
 * ignore Acknowledge and drop; recorded in the integration audit only.
 */
export type EntityPauseMode = 'hold' | 'ignore';

export interface EntityPause {
  entityType: string;
  mode: EntityPauseMode;
  reason?: string;
  pausedBy?: string;
  pausedAt?: string;
}

export interface EntityPauseList {
  pauses: EntityPause[];
  /** Upper bound, in seconds, for a change to reach every processor. */
  propagationSeconds: number;
}

export async function listEntityPauses(): Promise<EntityPauseList> {
  return apiClient.get('/api/entities/pauses');
}

export async function pauseEntity(
  entityType: string,
  mode: EntityPauseMode,
  reason?: string,
): Promise<{ pause: EntityPause; propagationSeconds: number }> {
  return apiClient.put(`/api/entities/${encodeURIComponent(entityType)}/pause`, {
    mode,
    ...(reason ? { reason } : {}),
  });
}

export async function resumeEntity(
  entityType: string,
): Promise<{ resumed: EntityPause; propagationSeconds: number }> {
  return apiClient.delete(`/api/entities/${encodeURIComponent(entityType)}/pause`);
}
